"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7955],{

/***/ 50156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var react_icons_tfi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73321);



var Modal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, title = param.title, children = param.children, footer = param.footer, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? 960 : _maxWidth, _contentPadding = param.contentPadding, contentPadding = _contentPadding === void 0 ? 24 : _contentPadding, _topOffset = param.topOffset, topOffset = _topOffset === void 0 ? 0 : _topOffset;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onKey = function(e) {
            if (e.key === "Escape") onClose();
        };
        if (isOpen) {
            document.addEventListener("keydown", onKey);
            document.body.style.overflow = "hidden";
        }
        return function() {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [
        isOpen,
        onClose
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "dialog",
        "aria-modal": "true",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10000,
            background: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "".concat(Math.max(20, topOffset + 20), "px 20px 20px 20px"),
            overflowY: "auto"
        },
        onClick: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                width: "100%",
                maxWidth: "min(".concat(maxWidth, "px, calc(100vw - 40px))"),
                background: "var(--color-background)",
                borderRadius: 16,
                border: "1px solid var(--color-gray-dark-800)",
                overflow: "hidden",
                boxShadow: "0px 3px 3px -1.5px var(--ColorsEffectsShadowsshadow-xl03), 0px 8px 8px -4px var(--ColorsEffectsShadowsshadow-xl02), 0px 20px 24px -4px var(--ColorsEffectsShadowsshadow-xl01)",
                maxHeight: "calc(100vh - ".concat(Math.max(20, topOffset + 20), "px - 20px)"),
                display: "flex",
                flexDirection: "column"
            },
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        padding: "24px",
                        borderBottom: "1px solid var(--color-gray-dark-800)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: onClose,
                            "aria-label": "Close",
                            style: {
                                background: "transparent",
                                border: "none",
                                color: "#61656C",
                                cursor: "pointer",
                                fontSize: 14,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tfi__WEBPACK_IMPORTED_MODULE_2__/* .TfiClose */ .u5Z, {})
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        padding: contentPadding,
                        overflowY: "auto",
                        overflowX: "hidden"
                    },
                    children: children
                }),
                footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        padding: 16,
                        borderTop: "1px solid var(--color-gray-dark-800)",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 12
                    },
                    children: footer
                }) : null
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ getProductSlugById; },
/* harmony export */   "WO": function() { return /* binding */ getProductIdBySlug; },
/* harmony export */   "Zc": function() { return /* binding */ productsData; }
/* harmony export */ });
var productsData = [
    {
        id: "6746ae8608b3efcbfedd1063",
        title: "Video Plugins",
        products: [
            {
                id: "6747fa1353ed45d740942f0d",
                product_name: "VxFX",
                icon: "/products/vxfx.png",
                slug: "vxfx"
            }, 
        ]
    }, 
];
/**
 * Finds product ID by slug
 * @param slug - The product slug
 * @returns Product ID or null if not found
 */ function getProductIdBySlug(slug) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.slug === slug;
            });
            if (product) {
                return product.id;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * Finds product slug by ID
 * @param id - The product ID
 * @returns Product slug or null if not found
 */ function getProductSlugById(id) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.id === id;
            });
            if (product) {
                return product.slug;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}


/***/ }),

/***/ 78193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ subscriptionService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15767);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81944);



var API_BASE = "https://api.vxfx.io" || 0;
var subscriptionService = {
    // Get plans (Public)
    getPlans: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(filters) {
            var params, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = new URLSearchParams();
                        if ((filters === null || filters === void 0 ? void 0 : filters.isActive) !== undefined) params.append("isActive", String(filters.isActive));
                        if (filters === null || filters === void 0 ? void 0 : filters.billingCycle) params.append("billingCycle", filters.billingCycle);
                        if ((filters === null || filters === void 0 ? void 0 : filters.hidden) !== undefined) params.append("hidden", String(filters.hidden));
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE, "/subscriptions/plans?").concat(params.toString()))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data || []
                        ];
                }
            });
        });
        return function(filters) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Get plan by ID (Public)
    getPlanById: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(id) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE, "/subscriptions/plans/").concat(id))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Create subscription (User - JWT Required)
    createSubscription: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(data) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat(API_BASE, "/subscriptions/my-subscriptions"), data, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Get user subscriptions (JWT Required)
    getUserSubscriptions: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var token, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    token = localStorage.getItem("auth-token");
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE, "/subscriptions/my-subscriptions"), {
                            headers: {
                                Authorization: token ? "Bearer ".concat(token) : ""
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data.data || res.data || []
                    ];
            }
        });
    }),
    // Get user subscription by ID (JWT Required)
    getUserSubscriptionById: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(id) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("".concat(API_BASE, "/subscriptions/my-subscriptions/").concat(id), {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Cancel subscription (JWT Required)
    cancelSubscription: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(subscriptionId) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("".concat(API_BASE, "/subscriptions/my-subscriptions/").concat(subscriptionId, "/cancel"), {}, {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(subscriptionId) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Update auto-renew (JWT Required)
    updateAutoRenew: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(subscriptionId, autoRenew) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("".concat(API_BASE, "/subscriptions/my-subscriptions/").concat(subscriptionId, "/auto-renew"), {
                                autoRenew: autoRenew
                            }, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(subscriptionId, autoRenew) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Delete subscription (JWT Required)
    deleteSubscription: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(subscriptionId) {
            var token;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["delete"] */ .Z["delete"]("".concat(API_BASE, "/subscriptions/my-subscriptions/").concat(subscriptionId), {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(subscriptionId) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Admin: Create plan
    createPlan: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(data) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat(API_BASE, "/subscriptions/plans"), data, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Admin: Update plan
    updatePlan: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(planId, data) {
            var token, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("".concat(API_BASE, "/subscriptions/plans/").concat(planId), data, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.data.data || res.data
                        ];
                }
            });
        });
        return function(planId, data) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Admin: Delete plan
    deletePlan: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(planId) {
            var token;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["delete"] */ .Z["delete"]("".concat(API_BASE, "/subscriptions/plans/").concat(planId), {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(planId) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Create Stripe checkout session for subscription
    // Based on Stripe Payment Integration Guide
    createCheckoutSession: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(planId, currency, options) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, token, requestBody, res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = localStorage.getItem("auth-token");
                        requestBody = {
                            subscriptionPlanId: planId,
                            currency: currency,
                            supports: (options === null || options === void 0 ? void 0 : options.supports) || []
                        };
                        // Add optional fields if provided
                        if ((options === null || options === void 0 ? void 0 : options.additionalHosts) !== undefined) {
                            requestBody.additionalHosts = options.additionalHosts;
                        }
                        if ((options === null || options === void 0 ? void 0 : options.additionalHardware) !== undefined) {
                            requestBody.additionalHardware = options.additionalHardware;
                        }
                        if ((options === null || options === void 0 ? void 0 : options.selectedDuration) !== undefined) {
                            requestBody.selectedDuration = options.selectedDuration;
                        }
                        if ((options === null || options === void 0 ? void 0 : options.os) && options.os.length > 0) {
                            requestBody.os = options.os;
                        }
                        if ((options === null || options === void 0 ? void 0 : options.maxWorkflowRunsPerProduct) !== undefined) {
                            requestBody.maxWorkflowRunsPerProduct = options.maxWorkflowRunsPerProduct;
                        }
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("".concat(API_BASE, "/subscriptions/checkout"), requestBody, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        // Free plan: backend activates the subscription immediately and returns it
                        // instead of a Stripe checkout session (Stripe cannot charge a 0 amount).
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.success) && ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.subscription) && !((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.session)) {
                            return [
                                2,
                                {
                                    free: true,
                                    subscription: res.data.subscription
                                }
                            ];
                        }
                        // Paid plan response format: { success: true, session: { url: "..." } }
                        if (((ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.success) && ((ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.session) === null || ref5 === void 0 ? void 0 : ref5.url)) {
                            return [
                                2,
                                {
                                    free: false,
                                    url: res.data.session.url
                                }
                            ];
                        }
                        // Fallback for different response formats
                        return [
                            2,
                            {
                                free: false,
                                url: ((ref6 = res.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.session) === null || ref7 === void 0 ? void 0 : ref7.url) || ((ref8 = res.data) === null || ref8 === void 0 ? void 0 : ref8.url) || ((ref9 = res.data) === null || ref9 === void 0 ? void 0 : ref9.checkoutUrl) || ""
                            }
                        ];
                }
            });
        });
        return function(planId, currency, options) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ })

}]);